import { makeObservable, observable, action } from "mobx";
import { SingletonClass } from "@/app/utils/SingletonClass";

/**
 * Описание ожидающей модалки.
 * Union-тип: добавляй новые варианты по мере роста приложения.
 */
export type PendingModal =
  | {
      type: "subscription_purchased";
      productName: string;
      features: string[];
    };

/**
 * Центральное хранилище кросс-фичевого состояния приложения.
 *
 * Назначение: хранить состояния, которые должны пережить навигацию
 * и не принадлежат ни одной конкретной фиче (pending-модалки, флаги онбординга и т.д.)
 *
 * Расширяй тип PendingModal новыми вариантами — реализация AppStore менять не нужно.
 */
export class AppStore extends SingletonClass {
  private static _instance: AppStore;

  pendingModal: PendingModal | null = null;

  static getInstance(): AppStore {
    if (!AppStore._instance) {
      AppStore._instance = new AppStore();
    }
    return AppStore._instance;
  }

  constructor() {
    super();
    makeObservable(this, {
      pendingModal: observable,
      schedulePendingModal: action,
      clearPendingModal: action,
    });
  }

  /**
   * Ставит модалку в очередь на показ.
   * Если модалка уже есть — заменяет (предполагается показ одной за раз).
   */
  schedulePendingModal(modal: PendingModal): void {
    this.pendingModal = modal;
  }

  /**
   * Закрывает текущую модалку и очищает очередь.
   */
  clearPendingModal(): void {
    this.pendingModal = null;
  }
}
